<template>
  <div class="content bg8">
      <div class="explore-programs-dropdown" style="text-align:center;padding:24px 16px 18px 16px;background:#fff;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <label for="program-select" class="dropdown-label" style="font-weight:600;color:#7a4fa3;font-size:1.1rem;margin-bottom:10px;display:block;">Explore Internship Programs</label>
        <select id="program-select" class="program-select" @change="onProgramChange" :value="$route.path">
          <option value="/digital-marketing-internship">Digital Marketing</option>
          <option value="/social-media-marketing-internship">Social Media Marketing</option>
          <option value="/content-creation-internship">Content Creation and Copywriting</option>
          <option value="/website-design-internship">Website Design</option>
          <option value="/data-analytics-internship">Data Analytics and BI</option>
          <option value="/graphic-design-internship">Graphic Design</option>
        </select>
      </div>
      <div class="middled">
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      <div class="basehero">
        <h1>Social Media Marketing Internship Program</h1>
        <h2 class="section">Grow a Brand—and a Career—Together</h2>
        <p>
          Social media is where brands connect, grow, and come to life. The Foclarity Social Media Marketing Internship Program matches startups with talented, motivated interns who are ready to build bold campaigns from the ground up.
        </p>
        <p>
          Interns gain real-world experience managing social media accounts, engaging communities, and crafting content that resonates. Startups get a team of energetic marketers trained to increase visibility, spark conversations, and grow an authentic presence online.
        </p>
        <hr>
        <h3>For Startups:</h3>
        <strong>Social Presence with Purpose</strong>
        <p>
          Whether you're launching your brand or scaling your message, our interns can help you punch above your weight on social media.
        </p>
        <ul>
          <li>A curated team of social-savvy interns to match your startup’s brand and goals</li>
          <li>Campaign planning, scheduling, and posting support across key platforms</li>
          <li>Audience engagement and community management with your voice in mind</li>
          <li>Weekly insights and reporting to track growth and engagement</li>
          <li>Supervision and mentorship to ensure quality and consistency</li>
        </ul>
        <p>You stay focused on building your business—we’ll help you build your audience.</p>
        <hr>
        <h3>For Interns:</h3>
        <strong>Create. Connect. Learn by Doing.</strong>
        <p>
          This isn’t a fake internship with fake tasks. You’ll be managing actual campaigns for actual startups—learning what works and what doesn’t in real time.
        </p>
        <ul>
          <li>Hands-on experience in social strategy, calendar planning, and analytics</li>
          <li>Practice crafting engaging content across platforms like Instagram, LinkedIn, TikTok, and X</li>
          <li>Training in tools like Buffer, Canva, Meta Business Suite, and more</li>
          <li>Feedback and mentorship to help you level up quickly</li>
          <li>A portfolio of published work to show employers what you’ve accomplished</li>
        </ul>
        <blockquote style="margin: 24px 20%; font-style: italic; color: #7a4fa3; border-left: 4px solid #BF00FF; padding-left: 16px;">
          “I went from posting on my personal account to building a social strategy for a startup. Foclarity gave me confidence—and skills I now use in my full-time role.”<br>
          <span style="font-size: 0.95em; color: #41037b;">— Former Social Media Intern</span>
        </blockquote>
        <hr>
        <h3>What You’ll Work On</h3>
        <ul>
          <li>Social media strategy and campaign planning</li>
          <li>Content creation and publishing schedules</li>
          <li>Brand voice development and engagement</li>
          <li>Audience growth and community management</li>
          <li>Analytics, reporting, and iteration based on performance</li>
        </ul>
        <hr>
        <h3>How It Works</h3>
        <ol>
          <li><strong>Apply</strong>: Fill out a quick application as an intern or startup.</li>
          <li><strong>Match</strong>: We pair you based on your goals, style, and experience.</li>
          <li><strong>Launch</strong>: Start planning and posting right away with a kickoff call.</li>
          <li><strong>Grow</strong>: Learn from real-time feedback, analytics, and campaign impact.</li>
        </ol>
        <hr>
        <h3>Ready to Build Your Brand?</h3>
        <p>
          If you're a startup ready to grow your audience—or a student ready to grow your skills—this is where your journey starts.
        </p>
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      </div>
      <!-- Friendly explore-more section at the end -->
      <div class="explore-programs" style="text-align:center;padding:32px 16px 24px 16px;background:#fff    ;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <h2 style="color:#7a4fa3;font-size:1.3rem;margin-bottom:16px;">Explore More Internship Programs</h2>
        <ul class="explore-list" style="list-style:none;padding:0;margin:0;">
          <li style="margin:10px 0;"><router-link to="/digital-marketing-internship" class="subnav-link">Digital Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/social-media-marketing-internship" class="subnav-link">Social Media Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/content-creation-internship" class="subnav-link">Content Creation and Copywriting</router-link></li>
          <li style="margin:10px 0;"><router-link to="/website-design-internship" class="subnav-link">Website Design</router-link></li>
          <li style="margin:10px 0;"><router-link to="/data-analytics-internship" class="subnav-link">Data Analytics and BI</router-link></li>
          <li style="margin:10px 0;"><router-link to="/graphic-design-internship" class="subnav-link">Graphic Design</router-link></li>
        </ul>
        <div style="margin-top:18px;">
          <router-link to="/who-we-serve" class="subnav-link" style="font-size:1.05em;">Back to All Programs</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMediaMarketingInternship",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.button-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.button-row a {
  display: inline-block;
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #BF00FF;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
</style>
